<template>
  <div class="footer-container">
    <div
      class="footer-content"
      :class="{ 'footer-background': !hideBackground }"
    >
      <div class="d-flex p-3 action-button-wrapper">
        <AppButton
          v-if="!hideSkipButton"
          block
          :rounded="rounded"
          variant="gray-03"
          @click="$emit('skip')"
          data-testid="skipButton"
        >
          {{ skipButtonText }}
        </AppButton>
        <AppButton
          block
          :rounded="rounded"
          @click="$emit('submit')"
          :disabled="disabled"
          data-testid="submitButton"
          class="mt-0"
        >
          {{ submitButtonText }}
        </AppButton>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import AppButton from "@/components/atoms/button/AppButton.vue";
import { Component, Prop, Vue } from "vue-facing-decorator";
@Component({
  components: {
    AppButton
  }
})
export default class BottomFormActionButtons extends Vue {
  @Prop({
    type: String,
    default: "登録して次へ"
  })
  submitButtonText!: string;

  @Prop({
    type: String,
    default: "スキップする"
  })
  skipButtonText!: string;

  @Prop({
    type: Boolean,
    default: false
  })
  hideSkipButton!: boolean;

  @Prop({
    type: Boolean,
    default: false
  })
  hideBackground!: boolean;

  @Prop({
    type: Boolean,
    default: false
  })
  rounded!: boolean;

  @Prop({
    type: Boolean,
    default: false
  })
  disabled!: boolean;
}
</script>

<style lang="scss" scoped>
.footer-container {
  bottom: 0;
  padding-bottom: calc(120px + env(safe-area-inset-bottom));
}

.footer-content {
  position: fixed;
  bottom: 0;
  left: 0;
  z-index: 2;
  width: 100vw;
  padding-bottom: env(safe-area-inset-bottom);
}

.footer-background {
  background-color: #f9f9f9;
  box-shadow: 0 -1px 0 rgb(0 0 0 / 30%);
}

.action-button-wrapper {
  gap: 0.5rem;
}
</style>
